/**
 * キャンセル依頼メールの件名 `【キャンセルリクエスト S12345】`。
 *
 * 件名に入っていれば LLM を通さずにキャンセル依頼として扱い、注文番号で注文を特定する。顧客に書いて
 * もらう文字列なので、組み立て (マイページの案内ページが件名を画面に出す) と読み取り (受信した
 * メールの判定) を同じモジュールに置いてずれないようにする。フロントからも import するので純粋関数だけ。
 */

const LABEL = "キャンセルリクエスト";

/** 件名に入れる文字列。`code` は "S12345" / "#S12345" のどちらでもよい。 */
export const buildCancelRequestSubject = (code: string): string =>
  `【${LABEL} ${code.replace(/^#/, "").toUpperCase()}】`;

/** 全角英数字・全角空白を半角に寄せる (顧客が手で打ち直した件名も拾う)。 */
const toHalfWidth = (s: string): string =>
  s
    .replace(/[Ａ-Ｚａ-ｚ０-９]/g, (ch) => String.fromCharCode(ch.charCodeAt(0) - 0xfee0))
    .replace(/　/g, " ");

/**
 * 括弧は 【】 と [] のどちらでも、ラベルと番号の間の空白は有無を問わない。番号は S / C + 数字
 * (大文字小文字は問わない)。`Re:` などの前置きが付いていても拾う (同じ注文の二度目以降の処理は
 * 呼び出し側が Shopify の印で止める)。
 */
const PATTERN = new RegExp(`[【\\[]\\s*${LABEL}\\s*#?([SC])\\s*(\\d+)\\s*[】\\]]`, "i");

/** 件名からキャンセル依頼の注文番号 ("S12345") を取り出す。入っていなければ null。 */
export const extractCancelRequestCode = (subject: string | null | undefined): string | null => {
  if (!subject) return null;
  const [, prefix, digits] = PATTERN.exec(toHalfWidth(subject)) ?? [];
  if (!prefix || !digits) return null;
  return `${prefix.toUpperCase()}${digits}`;
};
